import React from "react";

import { Control, Step } from "src/components/common";
import { useControls } from "./hooks";

export const Controls = React.memo(() => {
  const { getStepProps, values } = useControls();
  return (
    <div className={values.styles.controls}>
      <Control type="double" text="УДВОИТЬ" />
      <Step {...getStepProps()} />
      <Control type="repeat" text="ПОВТОРИТЬ" />
    </div>
  );
});

Controls.displayName = "Controls";
